import React from 'react';

const EMOJI_CATEGORIES = [
  {
    name: 'Smileys',
    emojis: ['😀', '😁', '😂', '🤣', '😊', '😇', '🥰', '😍', '🤩', '😘', '😜', '🤪', '😎', '🤓', '🥳', '😤', '😭', '😱', '🤔', '🤫', '😴', '🥱', '😷', '🤡', '👻', '🙄', '😬', '🫠', '🫡', '🫣'],
  },
  {
    name: 'Hands',
    emojis: ['👋', '🤚', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🫰', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '🫶', '👐', '🤝', '🙏'],
  },
  {
    name: 'Objects',
    emojis: ['💻', '🖥️', '📱', '⌨️', '🖱️', '💾', '📸', '🎮', '🎧', '🎵', '🎨', '🔧', '🔨', '⚡', '🔥', '💡', '📦', '🎯', '🏆', '🎪', '💬', '💭', '📝', '📌', '📎', '🔗', '📊', '📈', '🗂️', '📁'],
  },
  {
    name: 'Symbols',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💯', '✅', '❌', '⭐', '🌟', '💫', '🎉', '🎊', '💪', '🚀', '🔴', '🟢', '🔵', '🟡', '⚠️', '❗', '❓', '♻️', '🏁', '🔔', '💎', '🌈'],
  },
];

function EmojiPicker({ onSelect, onClose }) {
  return (
    <div className="emoji-picker">
      <div className="emoji-picker-header">
        <span>Emojis</span>
        <button className="emoji-picker-close" onClick={onClose}>&times;</button>
      </div>
      <div className="emoji-picker-body">
        {EMOJI_CATEGORIES.map((cat) => (
          <div key={cat.name} className="emoji-category">
            <div className="emoji-category-name">{cat.name}</div>
            <div className="emoji-grid">
              {cat.emojis.map((emoji, i) => (
                <button
                  key={i}
                  className="emoji-item"
                  onClick={() => onSelect(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmojiPicker;
